import styled from 'styled-components';

export const HeaderStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  font-family: IBMPlexSans;
  font-weight: 500;
  font-size: 18px;
  padding-bottom: 20px;
`;

export const BodyStyled = styled.div`
  width: 100%;

  & .sketch-picker {
    padding: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
  }
`;
